import React, { useState, useEffect } from 'react';
import { FaFileContract, FaTimes, FaExternalLinkAlt, FaFilePdf } from 'react-icons/fa';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const PDF_PATH = `${BASE_URL}/uploads/sambutan/Kebijakan_PrivasiBpkad_Kota_Magelang.pdf`;

const KebijakanPrivasiButton = () => {
    const [open, setOpen] = useState(false);

    // Lock scroll + ESC saat modal terbuka
    useEffect(() => {
        if (!open) return;

        const handleEsc = (e) => {
            if (e.key === 'Escape') setOpen(false);
        };

        document.addEventListener('keydown', handleEsc);
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = originalOverflow;
        };
    }, [open]);

    return (
        <>
            {/* ✅ Tombol Floating Kanan Bawah */}
            <button
                onClick={() => setOpen(true)}
                className="fixed bottom-6 right-6 z-40 bg-white hover:bg-gray-50 text-[#0F4C3A] border-2 border-[#0F4C3A] px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 font-semibold text-sm group"
                title="Lihat Kebijakan Privasi"
                aria-label="Kebijakan Privasi"
            >
                <FaFileContract className="text-lg group-hover:scale-110 transition-transform" />
                <span className="hidden sm:inline">Kebijakan Privasi</span>
            </button>

            {/* ✅ Modal PDF Viewer */}
            {open && (
                <div
                    className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
                    onClick={() => setOpen(false)}
                >
                    <div
                        className="relative w-full max-w-5xl h-[90vh] bg-white rounded-xl shadow-2xl flex flex-col overflow-hidden"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header */}
                        <div className="flex items-center justify-between p-4 border-b bg-gradient-to-r from-[#0F4C3A] to-[#2E7D32] text-white">
                            <div className="flex items-center gap-3 min-w-0">
                                <FaFilePdf className="text-2xl flex-shrink-0" />
                                <div className="min-w-0">
                                    <h3 className="font-bold text-lg truncate">
                                        Kebijakan Privasi
                                    </h3>
                                    <p className="text-xs opacity-80">
                                        BPKAD Kota Magelang
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-center gap-2 flex-shrink-0">
                                <button
                                    onClick={() => setOpen(false)}
                                    className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition"
                                    aria-label="Tutup"
                                    title="Tutup (ESC)"
                                >
                                    <FaTimes />
                                </button>
                            </div>
                        </div>

                        {/* Body PDF */}
                        <div className="flex-1 bg-gray-100 overflow-hidden">
                            <iframe
                                src={`${PDF_PATH}#toolbar=1&navpanes=0&scrollbar=1`}
                                title="Kebijakan Privasi"
                                className="w-full h-full border-0"
                            />
                        </div>

                        {/* Footer */}
                        <div className="p-3 border-t bg-gray-50 flex justify-end">
                            <button
                                onClick={() => setOpen(false)}
                                className="border border-gray-300 hover:bg-gray-100 text-gray-700 px-4 py-2 rounded-lg text-sm transition"
                            >
                                Tutup
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default KebijakanPrivasiButton;